import "./App.css";
import React from "react";
import Rotas from "./routes/routes";


const App = () => {
  const pathname = window.location.pathname;

  return <Rotas pathname={pathname} />;
};

export default App;
